import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=03d05aec&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=03d05aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d05aec",
  null
  
)

export default component.exports